jQuery(function($) {
			
	// hide our element on page load
	$('.sales-copy .wrap').css('opacity', 0);

	$('.sales-copy .wrap').waypoint(function() {
		$('.sales-copy .wrap').addClass( 'animated fadeInUp' );
	},
	{
		offset: '70%',
		triggerOnce: true
	});
	
	// hide our element on page load
	$('.two-column-band.grey .wrap').css('opacity', 0);

	var accordionHeight = 0;
	var elementHeight = $('.two-column-band.grey .wrap').height();	
	if( $(".accordion-content").length ){
		accordionHeight = $(".accordion-content").height();
	}

	$('.two-column-band.grey .wrap').waypoint(function() {
		$('.two-column-band.grey .wrap').addClass( 'animated fadeInUp' );
	},
	{
		offset: function(){
			var percentOffset = .8;
			var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
			var offset = h * percentOffset + elementHeight;
			//then account for accordion if present
			if(accordionHeight){
				offset += accordionHeight;
			}
			return offset;
		},
		triggerOnce: true
	});
	
	// hide our element on page load
	$('.two-column-band.white .wrap').css('opacity', 0);

	$('.two-column-band.white .wrap').waypoint(function() {
		$('.two-column-band.white .wrap').addClass( 'animated fadeInUp' );
	},
	{
		offset: '80%',
		triggerOnce: true
	});
	
	// hide our element on page load
	$('#band-1 .wrap').css('opacity', 0);

	$('#band-1 .wrap').waypoint(function() {
		$('#band-1 .wrap').addClass( 'animated fadeInUp' );
	},
	{
		offset: '70%',
		triggerOnce: true
	});
	
	// hide our element on page load
	$('#band-3 .wrap').css('opacity', 0);

	$('#band-3 .wrap').waypoint(function() {
		$('#band-3 .wrap').addClass( 'animated fadeInUp' );
	},
	{
		offset: '80%',
		triggerOnce: true
	});
	
	// hide our element on page load
	$('#band-5 .wrap').css('opacity', 0);

	$('#band-5 .wrap').waypoint(function() {
		$('#band-5 .wrap').addClass( 'animated fadeInUp' );
	},
	{
		offset: '80%',
		triggerOnce: true
	});
	
	// hide our element on page load
	$('#band-7 .wrap').css('opacity', 0);

	$('#band-7 .wrap').waypoint(function() {
		$('#band-7 .wrap').addClass( 'animated fadeInUp' );
	},
	{
		offset: '80%',
		triggerOnce: true
	});
	
	// hide our element on page load
	$('.features-benefits .wrap').css('opacity', 0);

	$('.features-benefits .wrap').waypoint(function() {
		$('.features-benefits .wrap').addClass( 'animated fadeInUp' );
	},
	{
		offset: '80%',
		triggerOnce: true
	});
	
	// hide our element on page load
	$('.controller-header .one-third.first').css('opacity', 0);

	$('.controller-header .one-third.first').waypoint(function() {
		$('.controller-header .one-third.first').addClass( 'animated fadeInUp' );
	},
	{
		offset: '80%',
		triggerOnce: true
	});
	
	// hide our element on page load
	$('.main-content .controller-image').css('opacity', 0);

	$('.main-content .controller-image').waypoint(function() {
		$('.main-content .controller-image').addClass( 'animated fadeInUp' );
	},
	{
		offset: '80%',
		triggerOnce: true
	});
	
	// hide our element on page load
	$('.qsr-flex3 .banded-content.grey .wrap').css('opacity', 0);

	$('.qsr-flex3 .banded-content.grey .wrap').waypoint(function() {
		$('.qsr-flex3 .banded-content.grey .wrap').addClass( 'animated fadeInUp' );
	},
	{
		offset: '80%',
		triggerOnce: true
	});

			
});